import React, { useCallback } from 'react';
import Modal from '@/common/components/Modal/index';
import modalStyles from '@/common/styles/modal-form-primary.less';
import { PrimaryAccountUser } from '@/common/containers/Forms/index';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useEditUserPersonaMutation } from '@/entities/decedent';

const INITIAL_VALUES = {
  email: '',
  firstName: '',
  lastName: '',
  middleName: '',
  mobilePhoneNumber: '',
  homePhoneNumber: '',
};

const EditPrimaryUser = ({ open = true, onClose, user, onSubmit }) => {
  const { t } = useTranslation();
  const editUserPersonaMutation = useEditUserPersonaMutation();
  const loading = editUserPersonaMutation.isPending;
  const submitHandler = onSubmit || editUserPersonaMutation.mutateAsync;
  const submitEdit = useCallback(
    (form) => {
      submitHandler({ id: user.id, form }).then(() => onClose());
    },
    [onClose, submitHandler, user?.id]
  );

  return (
    <Modal className={modalStyles.modal} open={open} overlay>
      <div className={modalStyles.modalHeader}>
        <h3>{t('Edit primary user')}</h3>
      </div>
      <div className={modalStyles.modalForm}>
        <PrimaryAccountUser
          className={modalStyles.modalBody}
          initialValues={user || INITIAL_VALUES}
          onSubmit={submitEdit}
          formId="editUser"
          hideBlockLabel
          disableEmail
        />
        <div className={modalStyles.modalFooter}>
          <div className={modalStyles.modalFooterBtns}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onClose}
              disabled={loading}
            >
              {t('Cancel')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              loading={loading}
              form="editUser"
            >
              {t('Save')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditPrimaryUser;
